import React, { FC, useEffect } from 'react';

import clsx from 'clsx';

import { useProductListFilters } from '@hooks/products-list-fiters';
import { useChipsSlider } from '@hooks/use-chips-slider';

import { CloseIcon } from '@components/icons';

import styles from './CategoryFilterChips.module.scss';

export type CategoryFilterChipsProps = {
    className?: string;
};

export const CategoryFilterChips: FC<CategoryFilterChipsProps> = (props) => {
    const { className } = props;

    const { viewportRef, emblaApi } = useChipsSlider();
    const { discardFilters, filtersChips } = useProductListFilters();

    // Reinitialization due to filter removal
    useEffect(() => {
        if (emblaApi === undefined) return;

        emblaApi.reInit();
    }, [filtersChips, emblaApi]);

    return (
        <div ref={viewportRef} className={clsx(styles.viewport, className)}>
            <ul className={styles.container}>
                {filtersChips.map(({ id, label, onClick }) => (
                    <li key={id} className={styles.chip} data-testid="filter-chip">
                        {label}
                        <button type="button" className={styles.removeButton} onClick={onClick}>
                            <CloseIcon className={styles.crossIcon} />
                        </button>
                    </li>
                ))}
                <li key="reset-button" className={styles.resetButtonWrapper}>
                    <button
                        type="button"
                        className={styles.resetButton}
                        onClick={() => discardFilters()}
                    >
                        Сбросить фильтры
                    </button>
                </li>
            </ul>
        </div>
    );
};
